/* Generated by restful-react */

import React from 'react'
import { Mutate, MutateProps, useMutate, UseMutateProps } from 'restful-react'

export const SPEC_VERSION = 'v5'

export interface SendPasswordLinkResponse {
  [key: string]: any
}

export interface SendPasswordLinkRequestBody {
  email: string
  type:
    | 'fleet_planner_reset_password_link'
    | 'fleet_planner_login_link'
    | 'tms_reset_password_link'
    | 'tms_login_link'
    | 'reset_password'
    | 'login_link'
}

export type SendPasswordLinkProps = Omit<
  MutateProps<
    SendPasswordLinkResponse,
    { [key: string]: any },
    void,
    SendPasswordLinkRequestBody,
    void
  >,
  'path' | 'verb'
>

/**
 * Send login or password reset email to a user
 */
export const SendPasswordLink = (props: SendPasswordLinkProps) => (
  <Mutate<SendPasswordLinkResponse, { [key: string]: any }, void, SendPasswordLinkRequestBody, void>
    verb='POST'
    path='/v5/users/password'
    {...props}
  />
)

export type UseSendPasswordLinkProps = Omit<
  UseMutateProps<
    SendPasswordLinkResponse,
    { [key: string]: any },
    void,
    SendPasswordLinkRequestBody,
    void
  >,
  'path' | 'verb'
>

/**
 * Send login or password reset email to a user
 */
export const useSendPasswordLink = (props: UseSendPasswordLinkProps) =>
  useMutate<
    SendPasswordLinkResponse,
    { [key: string]: any },
    void,
    SendPasswordLinkRequestBody,
    void
  >('POST', `/v5/users/password`, props)
